import { useContext } from 'react';

import { FriendGameContext } from './FriendGameContext';

export function useFriendGameCtx() {
  const ctx = useContext(FriendGameContext);
  return ctx;
}
